/*
 * @Author: caiqin.xie
 * @since: 2023-06-29 15:49:13
 * @lastTime: 2023-11-10 17:02:29
 * @LastEditors: caiqin.xie
 * @message: 新闻列表
 */
import React from "react";
import NewsItem from "../NewsItem";
import styles from "../../index.module.scss";
import { INews } from "@/common/types";

interface IProps {
  newsList: INews[]; // 新闻列表
  ctry: string;
}

const NewsList = (props:IProps) => {
  const {newsList, ctry} = props;

  return (
    <div className={styles['news-list']}>
      {newsList && newsList.map((item, index) => {
        if(index === 0) {
          return (
            <NewsItem
              key={item.id}
              newsData={item}
              ctry={ctry}
              className={styles['news-1']}
              imgClassName={styles['custom-news-pic']}
              contentClassName={styles['custom-news-content']} />
          )
        } else if ([1,2,3,4].includes(index)){
          return (
            <NewsItem
              key={item.id}
              ctry={ctry}
              newsData={item}
              className={styles['news-2']}
              imgClassName={styles['custom-news-pic']} />
          )
        } else {
          return (
            <NewsItem
              key={item.id}
              ctry={ctry}
              newsData={item}
              className={styles['news-3']}
              imgClassName={styles['custom-news-pic']} />
          )
        }
      })}
    </div>
  )
}

export default NewsList;
